import './App.css';
import Homepage from './components/Homepage/Homepage';
import ComingSoon from './components/ComingSoon/ComingSoon';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


// About Pages
import AboutRUK from './pages/About/AboutRUK';
import AboutEmblem from './pages/About/AboutEmblem';
import Gallery from './pages/About/Gallery';
import VCMessage from './pages/About/VCMessage';
import SuccessiveVCs from './pages/About/SuccessiveVCs';
import Vision from './pages/About/Vision';

// Administration Pages
import ViceChancellor from './pages/Administration/ViceChancellor';
import Rector from './pages/Administration/Rector';
import Registrar from './pages/Administration/Registrar';
import ExecutiveCouncil from './pages/Administration/ExecutiveCouncil';
import Officials from './pages/Administration/Officials';
import ResearchStudies from './pages/Administration/ResearchStudies';
import AdmissionsAdmin from './pages/Administration/Admissions';
import IQACAdmin from './pages/Administration/IQAC';
import CDC from './pages/Administration/CDC';
import AcademicAffairs from './pages/Administration/AcademicAffairs';

// Academics Pages
import BusinessManagement from './pages/Academics/BusinessManagement';
import Commerce from './pages/Academics/Commerce';
import Economics from './pages/Academics/Economics';
import English from './pages/Academics/English';
import Telugu from './pages/Academics/Telugu';
import Biochemistry from './pages/Academics/Biochemistry';
import Biotechnology from './pages/Academics/Biotechnology';
import Botany from './pages/Academics/Botany';
import Chemistry from './pages/Academics/Chemistry';
import Mathematics from './pages/Academics/Mathematics';
import Statistics from './pages/Academics/Statistics';
import Physics from './pages/Academics/Physics';
import Zoology from './pages/Academics/Zoology';
import ComputerScience from './pages/Academics/ComputerScience';
import FoodSciences from './pages/Academics/FoodSciences';
import ComputerScienceEngg from './pages/Academics/ComputerScienceEngg';
import Civil from './pages/Academics/Civil';
import Electronics from './pages/Academics/Electronics';
import Mechanical from './pages/Academics/Mechanical';
import Humanities from './pages/Academics/Humanities';



import ArtificialIntelligence from './pages/Academics/ArtificialIntelligence';
import CollegeOfScience from './pages/Academics/CollegeOfScience';
import EngineeringCollege from './pages/Academics/EngineeringCollege';

// Admissions Pages
import ApplyToRUK from './pages/Admissions/ApplyToRUK';
import Fees from './pages/Admissions/Fees';
import Scholarships from './pages/Admissions/Scholarships';

// Exam Cell Pages
// import AboutExamCell from './pages/ExamCell/About';
// import Officers from './pages/ExamCell/Officers';
// import Branch from './pages/ExamCell/Branch';
// import Calendar from './pages/ExamCell/Calendar';
// import Timetable from './pages/ExamCell/Timetable';
// import Results from './pages/ExamCell/Results';
// import Applications from './pages/ExamCell/Applications';
import ExaminationSection from './pages/ExamCell/ExaminationSection';

// Placement Cell Pages
import PlacementAbout from './pages/PlacementCell/About';
import PlacementVCMessage from './pages/PlacementCell/VCMessage';
import PlacementCommittee from './pages/PlacementCell/Committee';

// Library Page
import Library from './pages/Library/Library';
import EJournals from './pages/Library/EJournals';
import Guidelines from './pages/Library/Guidelines';
import OpenAccess from './pages/Library/OpenAccess';
import LibraryStaff from './pages/Library/Staff';

// More Pages
import IQACMore from './pages/More/IQAC';
import Disclosures from './pages/More/Disclosures';
// import Notifications from './pages/More/Notifications';
import Webmail from './pages/More/Webmail';
import Contact from './pages/More/Contact';
import AllNotifications from './components/Homepage/NotificationSection/AllNotifications';

// Admin Components
import AdminDashboard from './components/Admin/Dashboard';
import Academics from './components/NewSectionForAcadeimcResarchAdminsion/Academics';
import Admissions from './components/NewSectionForAcadeimcResarchAdminsion/Admissions';
import Research from './components/NewSectionForAcadeimcResarchAdminsion/Research';
//campus life components

import ICTLabs from './components/Homepage/CampusLife/ictlabs/ICTLabs';
import ScienceLabs from './components/Homepage/CampusLife/sciencelabs/ScienceLabs';
import UniversitySports from './components/Homepage/CampusLife/sports/UniversitySports';
import FacultyProfilePage from './pages/Academics/FacultyProfilePage';
//digital services components
import LMSPortal from './components/Homepage/Lms_Feedback_Alumni/LMSPortal';
import LMSCourseContent from './components/Homepage/Lms_Feedback_Alumni/LMSCourseContent';
import UniversityNSS from './components/Homepage/CampusLife/nss/UniversityNSS';
import CampusMap from './components/Homepage/CampusLife/colleges/CampusMap';
import Auditoriums from './components/Homepage/CampusLife/auditourim/Auditoriums';
import RegistrarOffice from './pages/Administration/RegistrarOffice';
// import AlumniPortal from './components/Homepage/Lms_Feedback_Alumni/AlumniPortal';
// import OnlineFeedbackSystem from './components/Homepage/Lms_Feedback_Alumni/OnlineFeedbackSystem'; 
import DigitalFlora from './pages/DigitalFlora/DigitalFlora.jsx';
import FloraDetails from './pages/DigitalFlora/FloraDetails.jsx';
import FloraQRGallery from './pages/DigitalFlora/FloraQRGallery.jsx';
import LeaveLogin from './leaves/LeaveLogin.jsx';
import EmployeeDashboard from './leaves/EmployeeDashboard';
import ApplyLeave from './leaves/ApplyLeave';
import MyApplications from './leaves/MyApplications';
import LeaveAdminDashboard from './leaves/AdminDashboard';
import EmployeeLeaveDetails from './leaves/EmployeeLeaveDetails';
import LeaveHome from "./leaves/LeaveHome";
import EmployeeAccounts from "./leaves/EmployeeAccounts";

import AllEmployeeLeaves from "./leaves/AllEmployeeLeaves";
import DistanceEducation from './pages/Administration/DistanceEducation';
import Placement from './pages/PlacementCell/Placement';
import InnovationIncubation from "./pages/InnovationIncubation/InnovationIncubation";
import Home from './pages/student-erp/Home.jsx';
import Login from './pages/student-erp/Login/Login.jsx';
import AdminDashboard1 from './pages/student-erp/AdminDashboard/AdminDashboard.jsx';
import StudentManagement from './pages/student-erp/StudentManagement/StudentManagement.jsx';
import StudentDashboard from './pages/student-erp/StudentDashboard/StudentDashboard.jsx';


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Homepage />} />
          {/* About Routes */}
          <Route path="/about/ruk" element={<AboutRUK />} />
          <Route path="/about/emblem" element={<AboutEmblem />} />
          <Route path="/about/gallery" element={<Gallery />} />
          <Route path="/about/vc-message" element={<VCMessage />} />
          <Route path="/about/successive-vcs" element={<SuccessiveVCs />} />
          <Route path="/about/vision" element={<Vision />} />

          {/* Administration Routes */}
          <Route path="/administration/vice-chancellor" element={<ViceChancellor />} />
          <Route path="/administration/rector" element={<Rector />} />
          <Route path="/administration/registrar" element={<Registrar />} />
          <Route path="/administration/executive-council" element={<ExecutiveCouncil />} />
          <Route path="/administration/officials" element={<Officials />} />
          <Route path="/administration/research-studies" element={<ResearchStudies />} />
          <Route path="/administration/admissions" element={<AdmissionsAdmin />} />
          <Route path="/administration/iqac" element={<IQACAdmin />} />
          <Route path="/administration/college-development" element={<CDC />} />
          <Route path="/administration/academic-affairs" element={<AcademicAffairs />} />
          <Route path='/administration/registraroffice' element={<RegistrarOffice />} />

          {/* Academics Routes */}
          <Route path="/academics/college-of-science" element={<CollegeOfScience />} />
          <Route path="/academics/engineering-college" element={<EngineeringCollege />} />
          <Route path="/academics/business-management" element={<BusinessManagement />} />
          <Route path="/academics/commerce" element={<Commerce />} />
          <Route path="/academics/economics" element={<Economics />} />
          <Route path="/academics/english" element={<English />} />
          <Route path="/academics/telugu" element={<Telugu />} />
          <Route path="/academics/biochemistry" element={<Biochemistry />} />
          <Route path="/academics/biotechnology" element={<Biotechnology />} />
          <Route path="/academics/botany" element={<Botany />} />
          <Route path="/academics/chemistry" element={<Chemistry />} />
          <Route path="/academics/mathematics" element={<Mathematics />} />
          <Route path="/academics/statistics" element={<Statistics />} />
          <Route path="/academics/physics" element={<Physics />} />
          <Route path="/academics/zoology" element={<Zoology />} />
          <Route path="/academics/computer-science" element={<ComputerScience />} />
          <Route path="/academics/food-science" element={<FoodSciences />} />
          <Route path="/academics/ai" element={<ArtificialIntelligence />} />
          <Route path="/academics/cse" element={<ComputerScienceEngg />} />
          <Route path="/academics/civil" element={<Civil />} />
          <Route path="/academics/electronics" element={<Electronics />} />
          <Route path="/academics/mechanical" element={<Mechanical />} />
          <Route path='/academics/humanities-basic-sciences' element={<Humanities />} />


          {/* Admissions Routes */}
          <Route path="/admissions/apply-to-ruk" element={<ApplyToRUK />} />
          <Route path="/admissions/fees" element={<Fees />} />
          <Route path="/admissions/scholarships" element={<Scholarships />} />

          {/* Exam Cell Routes */}
          <Route path="/examcell" element={<ExaminationSection />} />
          {/* <Route path="/examcell/about" element={<AboutExamCell />} />
          <Route path="/examcell/officers" element={<Officers />} />
          <Route path="/examcell/branch" element={<Branch />} />
          <Route path="/examcell/calendar" element={<Calendar />} />
          <Route path="/examcell/timetable" element={<Timetable />} />
          <Route path="/examcell/results" element={<Results />} />
          <Route path="/examcell/applications" element={<Applications />} /> */}

          {/* Placement Cell Routes */}
          <Route path="/placementcell/about" element={<PlacementAbout />} />
          <Route path="/placementcell/vc-message" element={<PlacementVCMessage />} />
          <Route path="/placementcell/committee" element={<PlacementCommittee />} />
          <Route path="/placementcell" element={<Placement />} />
          <Route
            path="/innovation-incubation-centre"
            element={<InnovationIncubation />}
          />

          {/* Library Route */}
          <Route path="/library" element={<Library />} />
          <Route path="/e-journals" element={<EJournals />} />
          <Route path="/guidelines" element={<Guidelines />} />
          <Route path="/open-access" element={<OpenAccess />} />
          <Route path="/staff" element={<LibraryStaff />} />
          <Route path="/distance-education" element={<DistanceEducation />} />

          {/* More Routes */}
          <Route path="/more/iqac" element={<IQACMore />} />
          <Route path="/more/disclosures" element={<Disclosures />} />
          <Route path="/more/notifications" element={<AllNotifications />} />
          <Route path="/more/webmail" element={<Webmail />} />
          <Route path="/more/contact" element={<Contact />} />
          <Route path="/digital-flora" element={<DigitalFlora />} />
          <Route
            path="/digital-flora/:id"
            element={<FloraDetails />}
          />
          <Route
            path="/digital-flora/qr-gallery"
            element={<FloraQRGallery />} />
          <Route path="/leave-portal" element={<LeaveHome />} />
          <Route path="/leave-portal/login" element={<LeaveLogin />} />
          {/* <Route
            path="/leave-portal"
            element={<LeaveLogin />}
          /> */}
          <Route
            path="/leave-portal/employee-dashboard"
            element={<EmployeeDashboard />}
          />

          <Route
            path="/leave-portal/apply"
            element={<ApplyLeave />}
          />

          <Route
            path="/leave-portal/my-applications"
            element={<MyApplications />}
          />

          <Route
            path="/leave-portal/admin-dashboard"
            element={<LeaveAdminDashboard />}
          />
          <Route
            path="/leave-portal/employee-details/:employeeId"
            element={<EmployeeLeaveDetails />}
          />
          <Route
            path="/leave-portal/employee-accounts"
            element={<EmployeeAccounts />}
          />
          <Route
            path="/leave-portal/all-employee-leaves"
            element={<AllEmployeeLeaves />}
          />
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />

          {/* Coming Soon Route */}
          <Route path="/coming-soon" element={<ComingSoon />} />
          new Section for academic, research and administartion
          <Route path="/academic" element={<Academics />} />
          <Route path="/research" element={<Research />} />
          <Route path="/admission" element={<Admissions />} />
          {/* campus CampusLife Routes */}
          <Route path="/campuslife/ict-labs" element={<ICTLabs />} />
          <Route path="/campuslife/science-labs" element={<ScienceLabs />} />
          <Route path='/campuslife/sports' element={<UniversitySports />} />
          <Route path='/campuslife/nss' element={<UniversityNSS />} />
          <Route path='/campuslife/college-buildings' element={<CampusMap />} />
          <Route path='/campuslife/auditorium' element={<Auditoriums />} />
          {/* student erp portal route */}
          <Route path="/student-erp" element={<Home />} />
          {/* <Route path="/student-erp" element={<StudentERP />} /> */}
          <Route path="/student-erp/login" element={<Login />} />
          <Route
            path="/student-erp/admin-dashboard"
            element={<AdminDashboard1 />}

          />
          <Route
            path="/student-erp/admin/students"
            element={<StudentManagement />}
          />
<Route
  path="/student-erp/student-dashboard"
  element={<StudentDashboard />}
/>
          {/* LMS Portal Route */}
          <Route path="/lms" element={<LMSPortal />} />
          <Route path="/lms/:courseId" element={<LMSCourseContent />} />
          {/* Alumni Portal Route */}
          {/* <Route path="/alumni" element={<AlumniPortal />} /> */}
          {/* Online Feedback System Route */}
          {/* <Route path="/online-feedback" element={<OnlineFeedbackSystem />} />   */}
          {/* faculty profile page route   */}
          <Route path="/faculty/:id" element={<FacultyProfilePage />} />
          {/* Fallback route */}
          <Route path="*" element={<Homepage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
